/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ModerationDefs from './defs.defs.js'

const $nsid = 'tools.ozone.moderation.scheduleAction'

export { $nsid }

/** Schedule a moderation action to be executed at a future time */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    action: l.typedUnion(
      [l.typedRef<Takedown>((() => takedown) as any)],
      false,
    ),
    subjects: l.array(l.string({ format: 'did' }), { maxLength: 100 }),
    createdBy: l.string({ format: 'did' }),
    scheduling: l.ref<SchedulingConfig>((() => schedulingConfig) as any),
    modTool: l.optional(
      l.ref<ModerationDefs.ModTool>((() => ModerationDefs.modTool) as any),
    ),
  }),
  l.payload(
    'application/json',
    l.ref<ScheduledActionResults>((() => scheduledActionResults) as any),
  ),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output

/** Schedule a takedown action */
type Takedown = {
  $type?: 'tools.ozone.moderation.scheduleAction#takedown'
  comment?: string

  /**
   * Indicates how long the takedown should be in effect before automatically expiring.
   */
  durationInHours?: number

  /**
   * If true, all other reports on content authored by this account will be resolved (acknowledged).
   */
  acknowledgeAccountSubjects?: boolean

  /**
   * Names/Keywords of the policies that drove the decision.
   */
  policies?: string[]

  /**
   * Severity level of the violation (e.g., 'sev-0', 'sev-1', 'sev-2', etc.).
   */
  severityLevel?: string

  /**
   * Number of strikes to assign to the user when takedown is applied.
   */
  strikeCount?: number

  /**
   * When the strike should expire. If not provided, the strike never expires.
   */
  strikeExpiresAt?: l.DatetimeString

  /**
   * Email content to be sent to the user upon takedown.
   */
  emailContent?: string

  /**
   * Subject of the email to be sent to the user upon takedown.
   */
  emailSubject?: string
}

export type { Takedown }

/** Schedule a takedown action */
const takedown = l.typedObject<Takedown>(
  $nsid,
  'takedown',
  l.object({
    comment: l.optional(l.string()),
    durationInHours: l.optional(l.integer()),
    acknowledgeAccountSubjects: l.optional(l.boolean()),
    policies: l.optional(l.array(l.string(), { maxLength: 5 })),
    severityLevel: l.optional(l.string()),
    strikeCount: l.optional(l.integer()),
    strikeExpiresAt: l.optional(l.string({ format: 'datetime' })),
    emailContent: l.optional(l.string()),
    emailSubject: l.optional(l.string()),
  }),
)

export { takedown }

/** Configuration for when the action should be executed */
type SchedulingConfig = {
  $type?: 'tools.ozone.moderation.scheduleAction#schedulingConfig'

  /**
   * Exact time to execute the action
   */
  executeAt?: l.DatetimeString

  /**
   * Earliest time to execute the action (for randomized scheduling)
   */
  executeAfter?: l.DatetimeString

  /**
   * Latest time to execute the action (for randomized scheduling)
   */
  executeUntil?: l.DatetimeString
}

export type { SchedulingConfig }

/** Configuration for when the action should be executed */
const schedulingConfig = l.typedObject<SchedulingConfig>(
  $nsid,
  'schedulingConfig',
  l.object({
    executeAt: l.optional(l.string({ format: 'datetime' })),
    executeAfter: l.optional(l.string({ format: 'datetime' })),
    executeUntil: l.optional(l.string({ format: 'datetime' })),
  }),
)

export { schedulingConfig }

type ScheduledActionResults = {
  $type?: 'tools.ozone.moderation.scheduleAction#scheduledActionResults'
  succeeded: l.DidString[]
  failed: FailedScheduling[]
}

export type { ScheduledActionResults }

const scheduledActionResults = l.typedObject<ScheduledActionResults>(
  $nsid,
  'scheduledActionResults',
  l.object({
    succeeded: l.array(l.string({ format: 'did' })),
    failed: l.array(l.ref<FailedScheduling>((() => failedScheduling) as any)),
  }),
)

export { scheduledActionResults }

type FailedScheduling = {
  $type?: 'tools.ozone.moderation.scheduleAction#failedScheduling'
  subject: l.DidString
  error: string
  errorCode?: string
}

export type { FailedScheduling }

const failedScheduling = l.typedObject<FailedScheduling>(
  $nsid,
  'failedScheduling',
  l.object({
    subject: l.string({ format: 'did' }),
    error: l.string(),
    errorCode: l.optional(l.string()),
  }),
)

export { failedScheduling }
